export class WordTaskPostfix {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get postfixAspect() {
        return this.wordTask.ownAspect.postfix;
    }
    get postfixString() {
        return this.postfixAspect.aspectContent.regional.allEnabledTextBasisStringsJoined;
    }
}
